import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const STORAGE_KEY = 'crays_cookie_consent';

type ConsentStatus = 'unknown' | 'accepted' | 'declined';

const consentSlice = createSlice({
  name: 'consent',
  initialState: {
    status: (localStorage.getItem(STORAGE_KEY) as ConsentStatus) || 'unknown' as ConsentStatus,
  },
  reducers: {
    setConsent(state, action: PayloadAction<'accepted' | 'declined'>) {
      state.status = action.payload;
      localStorage.setItem(STORAGE_KEY, action.payload);
    },
  },
});

export const { setConsent } = consentSlice.actions;
export default consentSlice.reducer;
export const selectConsentStatus = (s: { consent: { status: ConsentStatus } }) => s.consent.status;
